<ng-container *ngIf="(loaded$ | async) && !(maintenance$ | async)">
    <ng-container *ngIf="disabledSite && currentSite === 'de_de'">
        <section>
            <div class="container">
                <p>Diese Seite existiert nicht mehr. Bitte klicken Sie auf den folgenden Link <a
                        href="https://www.academy.draeger.com/partner/de-ext">https://www.academy.draeger.com/partner/de-ext</a>.</p>
        
                <p>This page no longer exists. Please click on the following link <a
                        href="https://www.academy.draeger.com/partner/de-ext">https://www.academy.draeger.com/partner/de-ext</a>.</p>
            </div>
        </section>
    </ng-container>
    <ng-container *ngIf="!disabledSite">
        <da-maintenance-overlay *ngIf="(isNotCountrySelectionPage$ | async)"></da-maintenance-overlay>
        <da-cookie-consent-overlay *ngIf="(isNotCountrySelectionPage$ | async) && (isOnlyDomain$ | async)=== false" (closeOverlay)="closeCookieOverlay($event)"></da-cookie-consent-overlay>
        <da-global-notification *ngIf="showCookieNotification$ | async"></da-global-notification>
        <da-header *ngIf="(isNotError500Page$ | async) && (showHeader$ | async)"></da-header>
        <da-breadcrumb *ngIf="(isNotError500Page$ | async) && (isNotCountrySelectionPage$ | async) && (showBreadcrumbs$ | async) && portalId !== 'de-ext'">
        </da-breadcrumb>
    </ng-container>
    <router-outlet></router-outlet>
    <ng-container *ngIf="!disabledSite">
        <da-contact-us-section *ngIf="(isNotCountrySelectionPage$ | async) && (showContact$ | async)" [portalHubSpotId]="portalHubSpotId$ | async"> </da-contact-us-section>
        <da-footer *ngIf="(isNotError500Page$ | async) && (showFooter$ | async)" [portalImprintUrl]="portalImprintUrl"></da-footer>
    </ng-container>    
</ng-container>
<ng-container *ngIf="maintenance$ | async">
    <da-header></da-header>
    <section class="background-color-nearwhite maintenance">
        <div class="container large">
            <p>
                Scheduled maintenance and release upgrade: The customer training portal will be temporarily unavailable on
                Tuesday, 25 November 2025, until Wednesday, 26 November 2025. Please try again later. Thank you for your
                understanding.

            </p>
            <p>                
                Geplante Wartungsarbeiten und Releasewechsel: Das Kunden‑Trainingsportal ist am Dienstag, den 25. November 2025
                bis Mittwoch, den 26. November 2025 vorübergehend nicht verfügbar. Bitte versuchen Sie es später erneut. Vielen
                Dank für Ihr Verständnis.

            </p>
        </div>
    </section>
    <da-footer></da-footer>
</ng-container>
